import type { UserProgress } from '../../types';

interface UserProgressProps {
  progress: UserProgress;
}

export default function UserProgress({ progress }: UserProgressProps) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Your Progress</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600">{progress.attempts}</div>
          <div className="text-sm text-gray-600">Attempts</div>
        </div>
        <div className="text-center">
          <div className={`text-2xl font-bold ${
            (progress.best_score ?? 0) >= 80 ? 'text-green-600' :
            (progress.best_score ?? 0) >= 60 ? 'text-yellow-600' : 'text-red-600'
          }`}>
            {progress.best_score}%
          </div>
          <div className="text-sm text-gray-600">Best Score</div>
        </div>
      </div>
    </div>
  );
}